// Library methods
import { useTranslation } from "react-i18next";

// Components
import { Box, Grid, Typography } from "@mui/material";

const SimultaneousResults = ({ simultaneousPerceptionResults }) => {
  // internationalization
  const { t } = useTranslation();

  return (
    <Box
      border="1px solid black"
      borderRadius="8px"
      p="20px"
      sx={{ width: "100%", height: "100%" }}
    >
      <Typography mb="20px">
        {t("word_simultaneous_perception_results")}
      </Typography>
      <Grid item xs={12} display="flex" flexDirection="column" gap="20px">
        <Box display="flex" justifyContent="space-around">
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap="8px"
            sx={{ width: "100%", height: "100%" }}
          >
            <Typography
              fontSize="14px"
              fontWeight={600}
              sx={{ textTransform: "capitalize" }}
            >
              {t("left_eye_image")}
            </Typography>
            <img
              alt="simultaneous perception results left eye slide"
              height="70%"
              width="70%"
              style={{
                borderRadius: "50%",
                border: "1px solid black",
              }}
              src={`data:image/png;base64,${simultaneousPerceptionResults?.slideSet?.leftEyeImage}`}
            />
          </Box>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap="8px"
            sx={{ width: "100%", height: "100%" }}
          >
            <Typography
              fontSize="14px"
              fontWeight={600}
              sx={{ textTransform: "capitalize" }}
            >
              {t("right_eye_image")}
            </Typography>
            <img
              alt="simultaneous perception results right eye slide"
              height="70%"
              width="70%"
              style={{
                borderRadius: "50%",
                border: "1px solid black",
              }}
              src={`data:image/png;base64,${simultaneousPerceptionResults?.slideSet?.rightEyeImage}`}
            />
          </Box>
        </Box>

        <Grid item xs={12} display="flex" justifyContent="space-around">
          <Box
            display="flex"
            flexDirection="column"
            textAlign="center"
            gap="4px"
          >
            <Typography fontWeight={600} fontSize="14px">
              {t("horizontal_deviation")}
            </Typography>
            <Typography fontSize="14px">
              {
                simultaneousPerceptionResults?.distanceHorizontalDeviationPrismDiopters
              }{" "}
              {t(
                simultaneousPerceptionResults?.distanceHorizontalDeviationType
              )}
            </Typography>
          </Box>

          <Box
            display="flex"
            flexDirection="column"
            textAlign="center"
            gap="4px"
          >
            <Typography fontWeight={600} fontSize="14px">
              {t("vertical_deviation")}
            </Typography>
            <Typography fontSize="14px">
              {
                simultaneousPerceptionResults?.distanceVerticalDeviationPrismDiopters
              }{" "}
              {t(simultaneousPerceptionResults?.distanceVerticalDeviationType)}
            </Typography>
          </Box>

          <Box
            display="flex"
            flexDirection="column"
            textAlign="center"
            gap="4px"
          >
            <Typography fontWeight={600} fontSize="14px">
              {t("word_torsion")}
            </Typography>
            <Typography fontSize="14px">
              {simultaneousPerceptionResults?.torsionDegrees}{" "}
              {simultaneousPerceptionResults?.torsionType}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SimultaneousResults;
